export const calculatWCPM = (totalWords, mistakesWords, reactionTime) => {
  //  Convert the number of seconds to a decimal by dividing the number of seconds by 60. This is the total reading time. Example: 175 / 60 = 2.91
  //  Divide the number of words read correctly by the total reading time in decimal form. Example: 130 / 2.91 = 45 WCPM
  const secondsadNumber = reactionTime / 60;
  return Math.round((totalWords - mistakesWords) / secondsadNumber);
};
  
